export default "__VITE_ASSET__e56f9a5d__"